import router from "@/router"
import i18n from "@/i18n/index"
import Discarded from "@/templates/operations/assets/Discarded.vue"
import Failed from "@/templates/operations/assets/Failed.vue"
import Next from "@/templates/operations/assets/Next.vue"
import Paused from "@/templates/operations/assets/Paused.vue"
import Progress from "@/templates/operations/assets/Progress.vue"
import Success from "@/templates/operations/assets/Success.vue"
import FailedStartedIcon from "@/templates/operations/assets/FailedStartedIcon.vue"
import NotStartedIcon from "@/templates/operations/assets/NotStartedIcon.vue"
import TimeoutIcon from "@/templates/operations/assets/TimeoutIcon.vue"
import InterruptedIcon from "@/templates/operations/assets/InterruptedIcon.vue"
import WindowsIcon from "@/components/icons/WindowsIcon.vue"
import MacIcon from "@/components/icons/MacIcon.vue"
import LinuxIcon from "@/components/icons/LinuxIcon.vue"
import SupportForm from "@/templates/support/components/SupportForm.vue"
import { CheckIcon, ExclamationIcon, XIcon } from "@heroicons/vue/outline"
import { createPinia } from "pinia"
import { createApp } from "vue"
import "@vuepic/vue-datepicker/dist/main.css"
import App from "./App.vue"
import "./index.css"

const app = createApp(App)

app
  .use(createPinia())
  .use(router)
  .use(i18n)
  .component("CheckIcon", CheckIcon)
  .component("ExclamationIcon", ExclamationIcon)
  .component("SuccessIcon", Success)
  .component("InterruptedIcon", InterruptedIcon)
  .component("FailedStartedIcon", FailedStartedIcon)
  .component("NotStartedIcon", NotStartedIcon)
  .component("TimeoutIcon", TimeoutIcon)
  .component("FailedIcon", Failed)
  .component("PausedIcon", Paused)
  .component("NextIcon", Next)
  .component("ProgressIcon", Progress)
  .component("DiscardedIcon", Discarded)
  .component("XIcon", XIcon)
  .component("SupportForm", SupportForm)
  .component("WindowsIcon", WindowsIcon)
  .component("LinuxIcon", LinuxIcon)
  .component("DarwinIcon", MacIcon)
  .mount("#app")

const appEnvironment =
  process.env.VITE_APP_ENVIRONMENT === "local"
    ? "dev"
    : process.env.VITE_APP_ENVIRONMENT

const raidStormBucketUrl = process.env.VITE_RAIDSTORM_BUCKET_URL
app.provide("RAIDSTORM_BUCKET_URL", `${raidStormBucketUrl}raid/`)
app.provide(
  "COMPANY_BUCKET_URL",
  `${raidStormBucketUrl}company_images/${appEnvironment}/`
)
app.provide(
  "BUCKET_HIGHLIGHT_URL",
  `${raidStormBucketUrl}content_highlights/${appEnvironment}`
)
